import { render, staticRenderFns } from "./CollectedHelp.vue?vue&type=template&id=dee577fc&scoped=true&lang=pug&"
import script from "./CollectedHelp.vue?vue&type=script&lang=js&"
export * from "./CollectedHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee577fc",
  null
  
)

export default component.exports